// extracted by mini-css-extract-plugin
export var blockedMessage = "_bb-3";
export var blockedOverlay = "_bb-1";
export var fadeIn = "_bb-2";
export var hereLink = "_bb-0";
export var slideUp = "_bb-4";